module.exports = __webpack_public_path__ + "img/product_2.8473c8d5.jpg";